let API_URL_2 = "https://passion-planner-api.herokuapp.com/api/oos";
// let API_URL_2 = "http://localhost:4000/api/oos"
/**
 * Send an AJAX request to https://passion-planner-api.herokuapp.com to trigger an email
 *
 * @param   {string}  email  email address
 *
 * @return  {string}         Response from API
 */
let oosNotification = async(email, product_id, product_title) => {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: API_URL_2,
            type: 'GET',
            data: {
                email: email,
                product_id: product_id,
                product_title: product_title,
            },
            success: function(data) {
                resolve(data)
            },
            error: function(error) {
                reject(error)
            },
        })
    })
}

/**
 * Create a new dataLayer with the downloadFile event
 *
 * @param   {string}  email  email address
 * @param   {integer}  product_id   Unique ID of the Shopify Product
 * @param   {string}  product_title  Unique Title of the Shopify Product
 *
 * @return  {void}                 [return description]
 */
let pushToGTM2 = (email, file, product_id, product_title) => {
    window.dataLayer = window.dataLayer || [];

    dataLayer.push({
        'event': 'OOS-Notification',
        'email': email,
        'product_id': product_id,
        'product_title': product_title
    })
}



$(document).ready(() => {
    let oosLink = $('#oos-subscribe');
    /**
     * Download Link click event
     *
     * @param   {callback}  async  [async description]
     * @param   {object}  event  [event description]
     *
     * @return  {void}         [return description]
     */
    oosLink.click(async(event) => {
        event.preventDefault()
            //Build Variables
        let link = $(event.target);
        let product_id = $(link).attr('data-product-id')
        let product_title = $(link).attr('data-product-title')
        let email = $('input#email').val()

        if (email != '') {
            // Initiate Email request
            await oosNotification(email, product_id, product_title)
            $('#oos-message').text('We will send you an e-mail once this product becomes available.')
            $('.oos-input').hide()
            $(event.target).prop('disabled', true)
                // Trigger GTM dataLayer push  event
            pushToGTM2(email, product_id, product_title)
        }
    })
});